import * as React from 'react';

function formatAirdate(timestamp) {
  let date = new Date();

  // Video airdates do not carry timezones, so the server sends a UTC version.
  // The client offset is applied here to reverse the native offset effects of
  // the get month / date / year functions
  date.setTime(timestamp * 1000);
  date.setTime(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));

  let year = (date.getFullYear() + '').substr(-2);

  return `${(date.getMonth() + 1)}/${date.getDate()}/${year}`;
}

export default class VideoDetails extends React.PureComponent {
  displaySeason() {
    let { season, show, episode } = this.props;

    return !!(
      show &&
      show.ordinal_season &&
      show.display_episode_number &&
      season &&
      season.ordinal &&
      episode &&
      episode.ordinal
    );
  }

  render() {
    return <span className="video-details">
      {
        this.displaySeason() &&
        <span>
          <span className="episode-season"><b>S</b>{this.props.season.ordinal}</span>
          &nbsp;
          <span className="episode-number"><b>E</b>{this.props.episode.ordinal}</span>
        </span>
      }
      {
        !this.displaySeason() &&
        <span className="episode-airdate">
          {formatAirdate(this.props.full_length.premiered_on)}
        </span>
      }
    </span>;
  }
}